// src/data/grammarQuestData.js
// Grammar Word Quest — Banco de Preguntas CEFR A2
// 20 preguntas pedagógicamente distribuidas para hispanohablantes

export const GRAMMAR_QUEST_QUESTIONS = {

  A1: [
    {
      id: 'a1-be-001', level: 'A1', grammar: 'Verb To Be (I am)',
      sentence: 'I ___ a teacher at a language school.',
      options: ['is', 'are', 'am', 'be', 'been'],
      answer: 'am',
      translation: 'Soy profesor en una escuela de idiomas.',
      tip: "Con 'I' siempre usamos 'am' (I am). Nunca 'I is' ni 'I are'.",
      collected_word: 'am', category: 'to_be',
    },
    {
      id: 'a1-be-002', level: 'A1', grammar: 'Verb To Be (she is)',
      sentence: 'She ___ from Mexico.',
      options: ['am', 'are', 'be', 'is', 'been'],
      answer: 'is',
      translation: 'Ella es de México.',
      tip: "Con he, she e it usamos 'is'.",
      collected_word: 'is', category: 'to_be',
    },
    {
      id: 'a1-be-003', level: 'A1', grammar: 'Verb To Be (they are)',
      sentence: 'They ___ my best friends.',
      options: ['is', 'am', 'are', 'be', 'does'],
      answer: 'are',
      translation: 'Ellos son mis mejores amigos.',
      tip: "Con you, we y they usamos 'are'.",
      collected_word: 'are', category: 'to_be',
    },
    {
      id: 'a1-be-004', level: 'A1', grammar: 'Verb To Be (negative)',
      sentence: 'My father ___ at home today. He is at work.',
      options: ["aren't", "isn't", "don't", 'not is', 'no is'],
      answer: "isn't",
      translation: 'Mi padre no está en casa hoy. Está en el trabajo.',
      tip: "La negativa de 'is' es 'is not' o 'isn't'. No uses 'don't' con el verbo to be.",
      collected_word: "isn't", category: 'to_be',
    },
    {
      id: 'a1-be-005', level: 'A1', grammar: 'There is / There are',
      sentence: 'There ___ a book on the table.',
      options: ['are', 'have', 'has', 'is', 'be'],
      answer: 'is',
      translation: 'Hay un libro sobre la mesa.',
      tip: "Usamos 'there is' con singular y 'there are' con plural. No digas 'there have'.",
      collected_word: 'there is', category: 'to_be',
    },
    {
      id: 'a1-noun-001', level: 'A1', grammar: 'Articles (a / an)',
      sentence: 'I eat ___ apple every morning.',
      options: ['a', 'any', 'many', 'much', 'an'],
      answer: 'an',
      translation: 'Como una manzana todas las mañanas.',
      tip: "Usamos 'an' antes de sonido de vocal (an apple, an egg) y 'a' antes de consonante (a book).",
      collected_word: 'an', category: 'nouns_articles',
    },
    {
      id: 'a1-noun-002', level: 'A1', grammar: 'Regular Plurals',
      sentence: 'There are three ___ in the classroom.',
      options: ['chair', 'chairs', 'chaires', "chair's", 'a chair'],
      answer: 'chairs',
      translation: 'Hay tres sillas en el salón.',
      tip: "Para formar el plural de la mayoría de los sustantivos agregamos '-s'.",
      collected_word: 'chairs', category: 'nouns_articles',
    },
    {
      id: 'a1-noun-003', level: 'A1', grammar: 'Irregular Plurals',
      sentence: 'Two ___ are playing in the park.',
      options: ['childs', 'child', 'childrens', 'children', 'childes'],
      answer: 'children',
      translation: 'Dos niños están jugando en el parque.',
      tip: "'Child' tiene plural irregular: 'children'. No lleva '-s' extra.",
      collected_word: 'children', category: 'nouns_articles',
    },
    {
      id: 'a1-verb-001', level: 'A1', grammar: 'Present Simple (negative)',
      sentence: "I ___ like coffee. I prefer tea.",
      options: ["doesn't", "don't", 'not', "am not", 'no'],
      answer: "don't",
      translation: 'No me gusta el café. Prefiero el té.',
      tip: "Con I, you, we y they la negativa usa 'don't' + verbo base.",
      collected_word: "don't", category: 'present_simple',
    },
    {
      id: 'a1-verb-002', level: 'A1', grammar: 'Present Simple (questions with do)',
      sentence: '___ you speak English?',
      options: ['Does', 'Are', 'Is', 'Have', 'Do'],
      answer: 'Do',
      translation: '¿Hablas inglés?',
      tip: "Las preguntas con you, I, we y they empiezan con 'Do'.",
      collected_word: 'do you', category: 'present_simple',
    },
    {
      id: 'a1-verb-003', level: 'A1', grammar: 'Present Simple (questions with does)',
      sentence: '___ she live in Dublin?',
      options: ['Do', 'Is', 'Does', 'Are', 'Has'],
      answer: 'Does',
      translation: '¿Ella vive en Dublín?',
      tip: "Con he, she e it usamos 'Does' y el verbo vuelve a su forma base (live, no lives).",
      collected_word: 'does she', category: 'present_simple',
    },
    {
      id: 'a1-pron-001', level: 'A1', grammar: 'Possessive Adjectives',
      sentence: 'This is Maria. ___ brother is very tall.',
      options: ['His', 'She', 'Hers', 'Their', 'Her'],
      answer: 'Her',
      translation: 'Esta es María. Su hermano es muy alto.',
      tip: "'Her' es el posesivo de 'she' (su, de ella). 'His' es de 'he'.",
      collected_word: 'her', category: 'pronouns',
    },
    {
      id: 'a1-pron-002', level: 'A1', grammar: 'Object Pronouns',
      sentence: 'Tom is my friend. I like ___ a lot.',
      options: ['he', 'his', 'her', 'they', 'him'],
      answer: 'him',
      translation: 'Tom es mi amigo. Me cae muy bien.',
      tip: "Después del verbo usamos pronombres objeto: him, her, them, me, us.",
      collected_word: 'him', category: 'pronouns',
    },
    {
      id: 'a1-prep-001', level: 'A1', grammar: 'Prepositions of Place (in)',
      sentence: 'The students are ___ the classroom.',
      options: ['on', 'at', 'of', 'to', 'in'],
      answer: 'in',
      translation: 'Los estudiantes están en el salón.',
      tip: "Usamos 'in' para estar dentro de un lugar cerrado (in the classroom, in the kitchen).",
      collected_word: 'in the classroom', category: 'prepositions',
    },
    {
      id: 'a1-modal-001', level: 'A1', grammar: 'Can (ability)',
      sentence: 'I ___ swim very well.',
      options: ['cans', 'am can', 'can to', 'can', 'cannot to'],
      answer: 'can',
      translation: 'Sé nadar muy bien.',
      tip: "'Can' no cambia con la persona y va seguido del verbo base (I can swim, she can swim).",
      collected_word: 'can', category: 'continuous_modals',
    },
    {
      id: 'a1-cont-001', level: 'A1', grammar: 'Present Continuous (basic)',
      sentence: 'Look! The baby ___ now.',
      options: ['sleeps', 'sleep', 'are sleeping', 'sleeping', 'is sleeping'],
      answer: 'is sleeping',
      translation: '¡Mira! El bebé está durmiendo ahora.',
      tip: "Para acciones que ocurren ahora usamos am/is/are + verbo con -ing.",
      collected_word: 'is sleeping', category: 'continuous_modals',
    },
    {
      id: 'a1-q-001', level: 'A1', grammar: 'Question Words (What)',
      sentence: '___ is your name?',
      options: ['Where', 'When', 'Why', 'How many', 'What'],
      answer: 'What',
      translation: '¿Cuál es tu nombre?',
      tip: "'What' pregunta por cosas o información. Para el nombre decimos 'What is your name?'.",
      collected_word: 'what', category: 'question_words',
    },
    {
      id: 'a1-q-002', level: 'A1', grammar: 'Question Words (Where)',
      sentence: '___ do you live? I live in Madrid.',
      options: ['What', 'Who', 'When', 'Why', 'Where'],
      answer: 'Where',
      translation: '¿Dónde vives? Vivo en Madrid.',
      tip: "'Where' pregunta por lugares.",
      collected_word: 'where', category: 'question_words',
    },
    {
      id: 'a1-vocab-001', level: 'A1', grammar: 'Vocabulary (days of the week)',
      sentence: 'Saturday comes before ___.',
      options: ['Friday', 'Thursday', 'Wednesday', 'Tuesday', 'Sunday'],
      answer: 'Sunday',
      translation: 'El sábado viene antes del domingo.',
      tip: "Los días de la semana siempre se escriben con mayúscula en inglés.",
      collected_word: 'Sunday', category: 'vocabulary',
    },
    {
      id: 'a1-vocab-002', level: 'A1', grammar: 'Vocabulary (colors)',
      sentence: 'The sky is ___ on a sunny day.',
      options: ['green', 'red', 'black', 'yellow', 'blue'],
      answer: 'blue',
      translation: 'El cielo es azul en un día soleado.',
      tip: "'Blue' = azul. Los adjetivos de color no cambian en plural: 'blue eyes'.",
      collected_word: 'blue', category: 'vocabulary',
    },
  ],
  A2: [
    {
      id: 'a2-verb-001',
      level: 'A2',
      grammar: 'Present Simple',
      sentence: 'She ___ breakfast at 8 a.m. every morning.',
      options: ['eat', 'eats', 'eating', 'ate', 'is eat'],
      answer: 'eats',
      translation: 'Ella desayuna a las 8 a.m. todas las mañanas.',
      tip: 'En presente simple con he, she o it, el verbo añade \'-s\' o \'-es\' (no digas \'she eat\' ni \'she is eat\').',
      collected_word: 'eats',
      category: 'present_simple',
    },
    {
      id: 'a2-verb-002',
      level: 'A2',
      grammar: 'Present Simple (have/has)',
      sentence: 'My brother ___ two cats and a golden retriever.',
      options: ['have', 'has', 'having', 'is having', 'haves'],
      answer: 'has',
      translation: 'Mi hermano tiene dos gatos y un golden retriever.',
      tip: 'Cuidado con el error común \'my brother have\'; la 3ª persona singular de \'have\' es siempre \'has\'.',
      collected_word: 'has',
      category: 'present_simple',
    },
    {
      id: 'a2-verb-003',
      level: 'A2',
      grammar: 'Past Simple (Regular)',
      sentence: 'Yesterday, we ___ delicious Italian pasta for dinner.',
      options: ['cook', 'cooked', 'cooks', 'are cooking', 'cookied'],
      answer: 'cooked',
      translation: 'Ayer cocinamos deliciosa pasta italiana para cenar.',
      tip: 'Para una acción completada en el pasado (\'yesterday\'), los verbos regulares agregan \'-ed\'.',
      collected_word: 'cooked',
      category: 'past_simple',
    },
    {
      id: 'a2-verb-004',
      level: 'A2',
      grammar: 'Past Simple (went)',
      sentence: 'Last weekend, they ___ to the beach by train.',
      options: ['go', 'goes', 'went', 'gone', 'goed'],
      answer: 'went',
      translation: 'El fin de semana pasado fueron a la playa en tren.',
      tip: '\'Go\' es un verbo irregular; su forma en pasado simple es \'went\' (nunca \'goed\').',
      collected_word: 'went',
      category: 'past_simple',
    },
    {
      id: 'a2-verb-005',
      level: 'A2',
      grammar: 'Present Continuous',
      sentence: 'Listen! Daniel is ___ the guitar in his room right now.',
      options: ['play', 'plays', 'playing', 'played', 'is play'],
      answer: 'playing',
      translation: '¡Escucha! Daniel está tocando la guitarra en su habitación ahora mismo.',
      tip: 'El Present Continuous se forma con el verbo \'to be\' + gerundio con \'-ing\' (\'is playing\').',
      collected_word: 'playing',
      category: 'continuous_modals',
    },
    {
      id: 'a2-verb-006',
      level: 'A2',
      grammar: 'Verb Agreement (agree)',
      sentence: 'I ___ with your opinion about flexible working hours.',
      options: ['am agree', 'agree', 'agrees', 'agreeing', 'am agreeing'],
      answer: 'agree',
      translation: 'Estoy de acuerdo con tu opinión sobre el horario laboral flexible.',
      tip: 'En inglés \'agree\' es un verbo, por lo que decimos \'I agree\', jamás \'I am agree\'.',
      collected_word: 'agree',
      category: 'present_simple',
    },
    {
      id: 'a2-prep-001',
      level: 'A2',
      grammar: 'Prepositions of Time (at/on/in)',
      sentence: 'Our project meeting starts ___ 9:30 a.m. sharp.',
      options: ['in', 'on', 'at', 'to', 'for'],
      answer: 'at',
      translation: 'Nuestra reunión de proyecto empieza a las 9:30 a.m. en punto.',
      tip: 'Usamos la preposición \'at\' para horas exactas y momentos puntuales del reloj.',
      collected_word: 'at',
      category: 'prepositions',
    },
    {
      id: 'a2-prep-002',
      level: 'A2',
      grammar: 'Prepositions of Time (days)',
      sentence: 'We usually play tennis together ___ Saturday mornings.',
      options: ['in', 'at', 'on', 'by', 'for'],
      answer: 'on',
      translation: 'Normalmente jugamos al tenis juntos los sábados por la mañana.',
      tip: 'Para días de la semana y partes de días específicos usamos \'on\' (\'on Saturday mornings\').',
      collected_word: 'on',
      category: 'prepositions',
    },
    {
      id: 'a2-prep-003',
      level: 'A2',
      grammar: 'Prepositions of Place (in)',
      sentence: 'Sophia has lived ___ Madrid for more than five years.',
      options: ['at', 'on', 'in', 'to', 'into'],
      answer: 'in',
      translation: 'Sophia ha vivido en Madrid durante más de cinco años.',
      tip: 'Para ciudades, países y espacios delimitados grandes usamos \'in\' (\'in Madrid\', \'in Spain\').',
      collected_word: 'in',
      category: 'prepositions',
    },
    {
      id: 'a2-prep-004',
      level: 'A2',
      grammar: 'Dependent Prepositions',
      sentence: 'Carlos is very interested ___ learning web design.',
      options: ['about', 'of', 'in', 'for', 'with'],
      answer: 'in',
      translation: 'Carlos está muy interesado en aprender diseño web.',
      tip: 'El adjetivo \'interested\' siempre va seguido de la preposición \'in\' (\'interested in\').',
      collected_word: 'interested in',
      category: 'prepositions',
    },
    {
      id: 'a2-adj-001',
      level: 'A2',
      grammar: 'Comparatives (regular)',
      sentence: 'Travelling by bullet train is ___ than taking the bus.',
      options: ['fast', 'faster', 'more fast', 'fastest', 'as fast'],
      answer: 'faster',
      translation: 'Viajar en tren bala es más rápido que tomar el autobús.',
      tip: 'Los adjetivos cortos de una sola sílaba como \'fast\' forman el comparativo añadiendo \'-er\' (\'faster than\').',
      collected_word: 'faster',
      category: 'comparatives',
    },
    {
      id: 'a2-adj-002',
      level: 'A2',
      grammar: 'Comparatives (irregular - better)',
      sentence: 'This modern laptop is much ___ than my old desktop computer.',
      options: ['gooder', 'more good', 'better', 'best', 'more better'],
      answer: 'better',
      translation: 'Esta laptop moderna es mucho mejor que mi vieja computadora de escritorio.',
      tip: '\'Good\' es irregular: su comparativo es \'better\' (nunca digas \'more good\' ni \'gooder\').',
      collected_word: 'better',
      category: 'comparatives',
    },
    {
      id: 'a2-adj-003',
      level: 'A2',
      grammar: 'Comparatives (long adjectives)',
      sentence: 'Eating at a restaurant is often ___ than cooking at home.',
      options: ['expensive', 'expensiver', 'more expensive', 'most expensive', 'as expensive'],
      answer: 'more expensive',
      translation: 'Comer en un restaurante a menudo es más caro que cocinar en casa.',
      tip: 'Para adjetivos largos de 3 o más sílabas usamos \'more + adjetivo\' (\'more expensive than\').',
      collected_word: 'more expensive',
      category: 'comparatives',
    },
    {
      id: 'a2-adv-001',
      level: 'A2',
      grammar: 'Frequency Adverbs (before main verb)',
      sentence: 'Elena ___ drinks a glass of fresh water before going to bed.',
      options: ['always', 'always is', 'is always', 'drank always', 'always to'],
      answer: 'always',
      translation: 'Elena siempre bebe un vaso de agua fresca antes de irse a dormir.',
      tip: 'Los adverbios de frecuencia van inmediatamente antes del verbo principal (\'always drinks\').',
      collected_word: 'always',
      category: 'frequency_adverbs',
    },
    {
      id: 'a2-adv-002',
      level: 'A2',
      grammar: 'Frequency Adverbs (after \'be\')',
      sentence: 'Lucas is ___ on time for his English morning classes.',
      options: ['never', 'usually', 'usually is', 'does usually', 'often is'],
      answer: 'usually',
      translation: 'Lucas usualmente llega a tiempo a sus clases matutinas de inglés.',
      tip: 'Con el verbo \'to be\', el adverbio de frecuencia se coloca DESPUÉS del verbo (\'is usually on time\').',
      collected_word: 'usually',
      category: 'frequency_adverbs',
    },
    {
      id: 'a2-adv-003',
      level: 'A2',
      grammar: 'Frequency Adverbs (rarely)',
      sentence: 'They ___ eat fast food because they prefer healthy home-cooked meals.',
      options: ['rarely', 'rare', 'are rarely', 'hardly', 'ever'],
      answer: 'rarely',
      translation: 'Rara vez comen comida rápida porque prefieren comidas caseras saludables.',
      tip: '\'Rarely\' significa \'rara vez\' y modifica directamente al verbo \'eat\' (\'they rarely eat\').',
      collected_word: 'rarely',
      category: 'frequency_adverbs',
    },
    {
      id: 'a2-conn-001',
      level: 'A2',
      grammar: 'Connectors (because)',
      sentence: 'I stayed at home last night ___ I was feeling exhausted.',
      options: ['because', 'so', 'but', 'although', 'and'],
      answer: 'because',
      translation: 'Me quedé en casa anoche porque me sentía agotado.',
      tip: 'Usamos \'because\' para introducir la causa o razón de una acción previa.',
      collected_word: 'because',
      category: 'connectors',
    },
    {
      id: 'a2-conn-002',
      level: 'A2',
      grammar: 'Connectors (so)',
      sentence: 'It started raining heavily, ___ we decided to take a taxi.',
      options: ['so', 'because', 'but', 'although', 'or'],
      answer: 'so',
      translation: 'Empezó a llover fuertemente, así que decidimos tomar un taxi.',
      tip: 'Usamos \'so\' para expresar el resultado o consecuencia de una situación.',
      collected_word: 'so',
      category: 'connectors',
    },
    {
      id: 'a2-vocab-001',
      level: 'A2',
      grammar: 'Vocabulary in Context (travel / airport)',
      sentence: 'Please keep your ___ with you at all times during the flight.',
      options: ['luggage', 'recipe', 'furniture', 'homework', 'traffic'],
      answer: 'luggage',
      translation: 'Por favor mantenga su equipaje con usted en todo momento durante el vuelo.',
      tip: '\'Luggage\' significa equipaje (es incontable en inglés, no se usa con plural -s).',
      collected_word: 'luggage',
      category: 'vocabulary',
    },
    {
      id: 'a2-vocab-002',
      level: 'A2',
      grammar: 'Vocabulary in Context (daily routines & work)',
      sentence: 'I have an important medical ___ with the doctor tomorrow at 11.',
      options: ['appointment', 'meeting', 'interview', 'journey', 'conversation'],
      answer: 'appointment',
      translation: 'Tengo una cita médica importante con el doctor mañana a las 11.',
      tip: 'En inglés, una cita médica o profesional con un especialista se llama \'appointment\' (no \'date\').',
      collected_word: 'appointment',
      category: 'vocabulary',
    },
  ],
    B1: [
    {
      id: 'b1-perf-001', level: 'B1', grammar: 'Present Perfect (since)',
      sentence: 'I have worked in this company ___ 2019.',
      options: ['for', 'since', 'from', 'during', 'ago'],
      answer: 'since',
      translation: 'He trabajado en esta empresa desde 2019.',
      tip: "Usamos 'since' + punto de inicio (2019, Monday) y 'for' + duración (five years).",
      collected_word: 'since', category: 'perfect_tenses',
    },
    {
      id: 'b1-perf-002', level: 'B1', grammar: 'Present Perfect (experience)',
      sentence: 'She ___ to Paris three times, so she knows the city well.',
      options: ['went', 'was going', 'has been', 'is going', 'goes'],
      answer: 'has been',
      translation: 'Ella ha estado en París tres veces, así que conoce bien la ciudad.',
      tip: "Para experiencias de vida sin fecha concreta usamos Present Perfect: 'has been'.",
      collected_word: 'has been', category: 'perfect_tenses',
    },
    {
      id: 'b1-perf-003', level: 'B1', grammar: 'Present Perfect (yet)',
      sentence: "I haven't received the confirmation email ___.",
      options: ['already', 'just', 'yet', 'ever', 'since'],
      answer: 'yet',
      translation: 'Todavía no he recibido el correo de confirmación.',
      tip: "'Yet' se usa en negativas y preguntas, normalmente al final de la frase (\"not ... yet\").",
      collected_word: 'yet', category: 'perfect_tenses',
    },
    {
      id: 'b1-cont-001', level: 'B1', grammar: 'Past Continuous',
      sentence: 'While I ___ dinner, the phone rang.',
      options: ['cooked', 'am cooking', 'was cooking', 'have cooked', 'cook'],
      answer: 'was cooking',
      translation: 'Mientras cocinaba la cena, sonó el teléfono.',
      tip: "Past Continuous (was/were + -ing) para la acción larga en progreso; Past Simple para la que la interrumpe.",
      collected_word: 'was cooking', category: 'continuous_modals',
    },
    {
      id: 'b1-cond-001', level: 'B1', grammar: 'First Conditional',
      sentence: 'If it ___ tomorrow, we will cancel the picnic.',
      options: ['rains', 'will rain', 'rained', 'would rain', 'is raining'],
      answer: 'rains',
      translation: 'Si llueve mañana, cancelaremos el picnic.',
      tip: "Primer condicional: if + presente simple, will + verbo. Nunca 'if it will rain'.",
      collected_word: 'rains', category: 'conditionals',
    },
    {
      id: 'b1-cond-002', level: 'B1', grammar: 'Second Conditional',
      sentence: 'If I ___ more money, I would travel around the world.',
      options: ['have', 'will have', 'had', 'would have', 'am having'],
      answer: 'had',
      translation: 'Si tuviera más dinero, viajaría por todo el mundo.',
      tip: "Segundo condicional (situación irreal): if + pasado simple, would + verbo.",
      collected_word: 'had', category: 'conditionals',
    },
    {
      id: 'b1-fut-001', level: 'B1', grammar: 'Future (going to - evidence)',
      sentence: 'Look at those dark clouds! It ___ rain.',
      options: ['is going to', 'will to', 'is go to', 'going to', 'does'],
      answer: 'is going to',
      translation: '¡Mira esas nubes oscuras! Va a llover.',
      tip: "Usamos 'be going to' para predicciones basadas en evidencia que vemos ahora.",
      collected_word: 'is going to', category: 'continuous_modals',
    },
    {
      id: 'b1-modal-001', level: 'B1', grammar: 'Modals of Obligation (must)',
      sentence: "You ___ wear a seat belt. It's the law.",
      options: ['might', 'may', 'must', 'would', 'can'],
      answer: 'must',
      translation: 'Debes usar el cinturón de seguridad. Es la ley.',
      tip: "'Must' expresa obligación fuerte o reglas. 'Might' y 'may' expresan posibilidad.",
      collected_word: 'must', category: 'continuous_modals',
    },
    {
      id: 'b1-modal-002', level: 'B1', grammar: "Absence of Obligation (don't have to)",
      sentence: 'You ___ pay to enter the museum on Sundays; it is free.',
      options: ["mustn't", "can't", "shouldn't", "don't have to", "haven't to"],
      answer: "don't have to",
      translation: 'No tienes que pagar para entrar al museo los domingos; es gratis.',
      tip: "'Don't have to' = no es necesario. 'Mustn't' = está prohibido. ¡Significan cosas muy distintas!",
      collected_word: "don't have to", category: 'continuous_modals',
    },
    {
      id: 'b1-pass-001', level: 'B1', grammar: 'Passive Voice (present)',
      sentence: 'English ___ in many countries around the world.',
      options: ['speaks', 'is speaking', 'speak', 'is spoken', 'spoken'],
      answer: 'is spoken',
      translation: 'El inglés se habla en muchos países del mundo.',
      tip: "Voz pasiva en presente: am/is/are + participio pasado ('is spoken').",
      collected_word: 'is spoken', category: 'passive_voice',
    },
    {
      id: 'b1-pass-002', level: 'B1', grammar: 'Passive Voice (past)',
      sentence: 'The Mona Lisa ___ by Leonardo da Vinci.',
      options: ['painted', 'was painted', 'is painted', 'has paint', 'was paint'],
      answer: 'was painted',
      translation: 'La Mona Lisa fue pintada por Leonardo da Vinci.',
      tip: "Voz pasiva en pasado: was/were + participio pasado ('was painted').",
      collected_word: 'was painted', category: 'passive_voice',
    },
    {
      id: 'b1-rel-001', level: 'B1', grammar: 'Relative Clauses (who)',
      sentence: 'The woman ___ lives next door is a nurse.',
      options: ['which', 'who', 'whose', 'where', 'what'],
      answer: 'who',
      translation: 'La mujer que vive al lado es enfermera.',
      tip: "Usamos 'who' para personas y 'which' para cosas. 'What' nunca introduce una cláusula relativa.",
      collected_word: 'who', category: 'relative_clauses',
    },
    {
      id: 'b1-rel-002', level: 'B1', grammar: 'Relative Clauses (where)',
      sentence: 'This is the café ___ we first met.',
      options: ['who', 'which', 'whose', 'where', 'when'],
      answer: 'where',
      translation: 'Este es el café donde nos conocimos.',
      tip: "Usamos 'where' para lugares: es el equivalente de 'donde'.",
      collected_word: 'where', category: 'relative_clauses',
    },
    {
      id: 'b1-pat-001', level: 'B1', grammar: 'Gerund after enjoy',
      sentence: 'She enjoys ___ to classical music while she works.',
      options: ['to listen', 'listen', 'listened', 'to listening', 'listening'],
      answer: 'listening',
      translation: 'Ella disfruta escuchar música clásica mientras trabaja.',
      tip: "Después de enjoy, avoid, finish, mind y suggest usamos gerundio (-ing).",
      collected_word: 'listening', category: 'verb_patterns',
    },
    {
      id: 'b1-pat-002', level: 'B1', grammar: 'Infinitive after decide',
      sentence: 'They decided ___ a new house last year.',
      options: ['buying', 'buy', 'bought', 'to buy', 'to buying'],
      answer: 'to buy',
      translation: 'Decidieron comprar una casa nueva el año pasado.',
      tip: "Después de decide, want, hope, plan y need usamos 'to' + infinitivo.",
      collected_word: 'to buy', category: 'verb_patterns',
    },
    {
      id: 'b1-pat-003', level: 'B1', grammar: 'Used to (past habits)',
      sentence: 'When I was a child, I ___ play football every afternoon.',
      options: ['use to', 'am used to', 'used to', 'was used to', 'using to'],
      answer: 'used to',
      translation: 'Cuando era niño, jugaba al fútbol todas las tardes.',
      tip: "'Used to' + verbo base expresa hábitos pasados que ya no existen. No es lo mismo que 'be used to' (estar acostumbrado).",
      collected_word: 'used to', category: 'verb_patterns',
    },
    {
      id: 'b1-prep-001', level: 'B1', grammar: 'Dependent Prepositions (afraid of)',
      sentence: 'My little sister is afraid ___ spiders.',
      options: ['from', 'of', 'about', 'with', 'for'],
      answer: 'of',
      translation: 'Mi hermana pequeña le tiene miedo a las arañas.',
      tip: "El adjetivo 'afraid' siempre va con 'of' (afraid of), no con 'from'.",
      collected_word: 'afraid of', category: 'prepositions',
    },
    {
      id: 'b1-phr-001', level: 'B1', grammar: 'Phrasal Verbs (turn down)',
      sentence: "Please turn ___ the music; I'm trying to sleep.",
      options: ['up', 'on', 'over', 'down', 'in'],
      answer: 'down',
      translation: 'Por favor baja la música; estoy intentando dormir.',
      tip: "'Turn down' = bajar el volumen. 'Turn up' = subirlo.",
      collected_word: 'turn down', category: 'phrasal_verbs',
    },
    {
      id: 'b1-conn-001', level: 'B1', grammar: 'Connectors (although)',
      sentence: '___ it was raining, we went for a long walk.',
      options: ['Because', 'So', 'But', 'Although', 'Despite of'],
      answer: 'Although',
      translation: 'Aunque estaba lloviendo, fuimos a dar un largo paseo.',
      tip: "'Although' + sujeto + verbo expresa contraste. No se combina con 'but' en la misma frase.",
      collected_word: 'although', category: 'connectors',
    },
    {
      id: 'b1-vocab-001', level: 'B1', grammar: 'Vocabulary in Context (work)',
      sentence: 'The company decided to ___ a new marketing manager next month.',
      options: ['rent', 'borrow', 'earn', 'lend', 'hire'],
      answer: 'hire',
      translation: 'La empresa decidió contratar a un nuevo director de marketing el próximo mes.',
      tip: "'Hire' = contratar a una persona. 'Rent' se usa para alquilar cosas (casas, coches).",
      collected_word: 'hire', category: 'vocabulary',
    },
  ],

  B2: [
    {
      id: 'b2-perf-001', level: 'B2', grammar: 'Present Perfect Continuous',
      sentence: 'Her eyes are red. She ___.',
      options: ['has cried', 'cries', 'is crying', 'has been crying', 'was cry'],
      answer: 'has been crying',
      translation: 'Tiene los ojos rojos. Ha estado llorando.',
      tip: "Present Perfect Continuous (have/has been + -ing) enfatiza una actividad reciente cuyo resultado se ve ahora.",
      collected_word: 'has been crying', category: 'perfect_tenses',
    },
    {
      id: 'b2-perf-002', level: 'B2', grammar: 'Past Perfect',
      sentence: 'When we arrived at the station, the train ___ already left.',
      options: ['has', 'have', 'did', 'had', 'was'],
      answer: 'had',
      translation: 'Cuando llegamos a la estación, el tren ya había salido.',
      tip: "Past Perfect (had + participio) para la acción que ocurrió ANTES de otra acción pasada.",
      collected_word: 'had left', category: 'perfect_tenses',
    },
    {
      id: 'b2-cond-001', level: 'B2', grammar: 'Third Conditional',
      sentence: 'If she had studied harder, she ___ the exam.',
      options: ['would pass', 'will pass', 'would have passed', 'had passed', 'passed'],
      answer: 'would have passed',
      translation: 'Si hubiera estudiado más, habría aprobado el examen.',
      tip: "Tercer condicional (pasado irreal): if + past perfect, would have + participio.",
      collected_word: 'would have passed', category: 'conditionals',
    },
    {
      id: 'b2-cond-002', level: 'B2', grammar: 'Wish + Past Simple',
      sentence: 'I wish I ___ more time to travel.',
      options: ['have', 'has', 'would have', 'will have', 'had'],
      answer: 'had',
      translation: 'Ojalá tuviera más tiempo para viajar.',
      tip: "Para deseos sobre el presente usamos 'wish' + pasado simple (como en el segundo condicional).",
      collected_word: 'wish I had', category: 'conditionals',
    },
    {
      id: 'b2-rep-001', level: 'B2', grammar: 'Reported Speech (statements)',
      sentence: 'He said that he ___ the report the day before.',
      options: ['has finished', 'finishes', 'will finish', 'had finished', 'is finishing'],
      answer: 'had finished',
      translation: 'Dijo que había terminado el informe el día anterior.',
      tip: "En estilo indirecto, el tiempo retrocede: past simple → past perfect.",
      collected_word: 'had finished', category: 'reported_speech',
    },
    {
      id: 'b2-rep-002', level: 'B2', grammar: 'Reported Questions',
      sentence: 'She asked me where ___.',
      options: ['was I going', 'did I go', 'do I go', 'I going', 'I was going'],
      answer: 'I was going',
      translation: 'Me preguntó adónde iba.',
      tip: "En preguntas indirectas el orden es de afirmación (sujeto + verbo), sin 'do/does/did' ni inversión.",
      collected_word: 'I was going', category: 'reported_speech',
    },
    {
      id: 'b2-pass-001', level: 'B2', grammar: 'Passive with Modals',
      sentence: 'The report ___ by Friday.',
      options: ['must finish', 'must finished', 'must be finish', 'has must finished', 'must be finished'],
      answer: 'must be finished',
      translation: 'El informe debe estar terminado para el viernes.',
      tip: "Pasiva con modales: modal + be + participio pasado ('must be finished').",
      collected_word: 'must be finished', category: 'passive_voice',
    },
    {
      id: 'b2-pass-002', level: 'B2', grammar: 'Causative (have something done)',
      sentence: 'I had my car ___ yesterday.',
      options: ['repair', 'repairing', 'to repair', 'repaired', 'repairs'],
      answer: 'repaired',
      translation: 'Hice reparar mi coche ayer.',
      tip: "Estructura causativa: have + objeto + participio pasado, cuando otra persona hace la acción por ti.",
      collected_word: 'repaired', category: 'passive_voice',
    },
    {
      id: 'b2-rel-001', level: 'B2', grammar: 'Non-defining Relative Clauses',
      sentence: 'The house, ___ was built in 1900, needs major repairs.',
      options: ['that', 'who', 'which', 'whose', 'where'],
      answer: 'which',
      translation: 'La casa, que fue construida en 1900, necesita grandes reparaciones.',
      tip: "En cláusulas entre comas (non-defining) nunca se usa 'that': se usa 'which' o 'who'.",
      collected_word: 'which', category: 'relative_clauses',
    },
    {
      id: 'b2-rel-002', level: 'B2', grammar: 'Relative Clauses (whose)',
      sentence: "That's the author ___ book won the national prize.",
      options: ['who', 'which', 'whom', 'whose', 'that'],
      answer: 'whose',
      translation: 'Ese es el autor cuyo libro ganó el premio nacional.',
      tip: "'Whose' expresa posesión ('cuyo/cuya') y va seguido de un sustantivo.",
      collected_word: 'whose', category: 'relative_clauses',
    },
    {
      id: 'b2-adv-001', level: 'B2', grammar: 'Inversion (Hardly ... when)',
      sentence: 'Hardly ___ arrived when it started to rain.',
      options: ['we had', 'did we', 'have we', 'we have', 'had we'],
      answer: 'had we',
      translation: 'Apenas habíamos llegado cuando empezó a llover.',
      tip: "Tras adverbios negativos (hardly, never, rarely) invertimos sujeto y auxiliar: 'Hardly had we...'.",
      collected_word: 'had we', category: 'advanced_structures',
    },
    {
      id: 'b2-modal-001', level: 'B2', grammar: 'Modals of Deduction (past)',
      sentence: 'The lights are off. They ___ gone to bed already.',
      options: ['must', 'should', 'can have', 'would', 'must have'],
      answer: 'must have',
      translation: 'Las luces están apagadas. Ya deben de haberse ido a dormir.',
      tip: "Para deducir algo del pasado con casi certeza: must have + participio.",
      collected_word: 'must have', category: 'continuous_modals',
    },
    {
      id: 'b2-modal-002', level: 'B2', grammar: 'Criticism (should have)',
      sentence: 'You ___ told me earlier; now it is too late to change the plan.',
      options: ['should', 'must', 'would', 'can', 'should have'],
      answer: 'should have',
      translation: 'Deberías habérmelo dicho antes; ahora es tarde para cambiar el plan.',
      tip: "'Should have' + participio expresa reproche o arrepentimiento por algo que no ocurrió.",
      collected_word: 'should have', category: 'continuous_modals',
    },
    {
      id: 'b2-pat-001', level: 'B2', grammar: 'Remember + Gerund',
      sentence: "I clearly remember ___ the door before leaving, so I don't understand how the thief got in.",
      options: ['to lock', 'lock', 'locked', 'to locking', 'locking'],
      answer: 'locking',
      translation: 'Recuerdo claramente haber cerrado la puerta con llave antes de salir, así que no entiendo cómo entró el ladrón.',
      tip: "'Remember + -ing' = recordar algo que ya hiciste. 'Remember + to' = acordarte de hacer algo.",
      collected_word: 'locking', category: 'verb_patterns',
    },
    {
      id: 'b2-pat-002', level: 'B2', grammar: 'Suggest + Gerund',
      sentence: 'She suggested ___ a taxi instead of walking.',
      options: ['to take', 'take', 'took', 'to taking', 'taking'],
      answer: 'taking',
      translation: 'Sugirió tomar un taxi en lugar de caminar.',
      tip: "'Suggest' va seguido de gerundio, nunca de 'to' + infinitivo (error muy común).",
      collected_word: 'taking', category: 'verb_patterns',
    },
    {
      id: 'b2-conn-001', level: 'B2', grammar: 'Connectors (despite)',
      sentence: '___ the heavy traffic, we arrived on time.',
      options: ['Although', 'However', 'Despite', 'Because', 'Unless'],
      answer: 'Despite',
      translation: 'A pesar del tráfico pesado, llegamos a tiempo.',
      tip: "'Despite' + sustantivo/gerundio. 'Although' necesita sujeto + verbo.",
      collected_word: 'despite', category: 'connectors',
    },
    {
      id: 'b2-conn-002', level: 'B2', grammar: 'Connectors (however)',
      sentence: 'The plan seemed perfect. ___, it failed.',
      options: ['Although', 'Despite', 'Because', 'Whereas', 'However'],
      answer: 'However',
      translation: 'El plan parecía perfecto. Sin embargo, fracasó.',
      tip: "'However' conecta dos oraciones independientes; va seguido de coma.",
      collected_word: 'however', category: 'connectors',
    },
    {
      id: 'b2-prep-001', level: 'B2', grammar: 'Dependent Prepositions (apologise for)',
      sentence: 'He apologised ___ being late to the meeting.',
      options: ['of', 'about', 'to', 'with', 'for'],
      answer: 'for',
      translation: 'Se disculpó por llegar tarde a la reunión.',
      tip: "'Apologise for' + gerundio. Con la persona usamos 'to': 'apologise to her for...'.",
      collected_word: 'apologise for', category: 'prepositions',
    },
    {
      id: 'b2-phr-001', level: 'B2', grammar: 'Phrasal Verbs (come up with)',
      sentence: 'We need to ___ a solution before the deadline.',
      options: ['put up with', 'run out of', 'look after', 'get along', 'come up with'],
      answer: 'come up with',
      translation: 'Necesitamos idear una solución antes de la fecha límite.',
      tip: "'Come up with' = idear o proponer (una idea, un plan, una solución).",
      collected_word: 'come up with', category: 'phrasal_verbs',
    },
    {
      id: 'b2-vocab-001', level: 'B2', grammar: 'Collocations (come into effect)',
      sentence: 'The new law will ___ into effect next January.',
      options: ['make', 'do', 'bring', 'get', 'come'],
      answer: 'come',
      translation: 'La nueva ley entrará en vigor el próximo enero.',
      tip: "Colocación fija: 'come into effect' = entrar en vigor.",
      collected_word: 'come into effect', category: 'vocabulary',
    },
  ],
    C1: [
    {
      id: 'c1-cond-001', level: 'C1', grammar: 'Mixed Conditional',
      sentence: 'If I had taken that job offer, I ___ in Singapore now.',
      options: ['would have lived', 'will live', 'had lived', 'am living', 'would be living'],
      answer: 'would be living',
      translation: 'Si hubiera aceptado esa oferta de trabajo, ahora estaría viviendo en Singapur.',
      tip: "Condicional mixto: pasado irreal (had + participio) con resultado en el presente (would + verbo).",
      collected_word: 'would be living', category: 'conditionals',
    },
    {
      id: 'c1-cond-002', level: 'C1', grammar: 'Wish + Past Perfect (regret)',
      sentence: 'I wish I ___ that email; it caused a lot of trouble.',
      options: ["didn't send", "wouldn't send", "haven't sent", "wasn't sending", "hadn't sent"],
      answer: "hadn't sent",
      translation: 'Ojalá no hubiera enviado ese correo; causó muchos problemas.',
      tip: "Para arrepentimientos sobre el pasado: wish + past perfect.",
      collected_word: "hadn't sent", category: 'conditionals',
    },
    {
      id: 'c1-cond-003', level: 'C1', grammar: 'Inverted Third Conditional',
      sentence: 'Had it not been for your help, we ___ the deadline.',
      options: ['would miss', 'will miss', 'had missed', 'missed', 'would have missed'],
      answer: 'would have missed',
      translation: 'De no ser por tu ayuda, habríamos perdido la fecha límite.',
      tip: "'Had + sujeto + participio' sustituye a 'If + had...' en un registro más formal.",
      collected_word: 'would have missed', category: 'conditionals',
    },
    {
      id: 'c1-adv-001', level: 'C1', grammar: 'Inversion (Should)',
      sentence: "___ you need any further assistance, don't hesitate to contact us.",
      options: ['Would', 'Had', 'Did', 'Might', 'Should'],
      answer: 'Should',
      translation: 'Si necesitara más ayuda, no dude en contactarnos.',
      tip: "'Should' al inicio equivale a 'If you should need...' y es muy común en correos formales.",
      collected_word: 'should', category: 'advanced_structures',
    },
    {
      id: 'c1-adv-002', level: 'C1', grammar: 'Inversion (Not only)',
      sentence: 'Not only ___ late, but he also forgot the documents.',
      options: ['he arrived', 'he did arrive', 'arrived he', 'was he arrive', 'did he arrive'],
      answer: 'did he arrive',
      translation: 'No solo llegó tarde, sino que además olvidó los documentos.',
      tip: "Después de 'Not only' al inicio, el auxiliar va antes del sujeto: 'did he arrive'.",
      collected_word: 'did he arrive', category: 'advanced_structures',
    },
    {
      id: 'c1-adv-003', level: 'C1', grammar: 'Subjunctive (insist that)',
      sentence: 'The manager insisted that she ___ present at the meeting.',
      options: ['is', 'was', 'would be', 'being', 'be'],
      answer: 'be',
      translation: 'El gerente insistió en que ella estuviera presente en la reunión.',
      tip: "Tras insist, suggest, demand o recommend + that, el subjuntivo usa el verbo base: 'that she be'.",
      collected_word: 'she be', category: 'advanced_structures',
    },
    {
      id: 'c1-adv-004', level: 'C1', grammar: 'Cleft Sentences (What ...)',
      sentence: 'What I need most right now ___ a good night of sleep.',
      options: ['are', 'be', 'has', 'do', 'is'],
      answer: 'is',
      translation: 'Lo que más necesito ahora es una buena noche de sueño.',
      tip: "En oraciones hendidas con 'What...', el verbo 'be' concuerda con el elemento que sigue.",
      collected_word: 'What ... is', category: 'advanced_structures',
    },
    {
      id: 'c1-adv-005', level: 'C1', grammar: 'Participle Clauses',
      sentence: '___ the instructions carefully, she assembled the shelf in minutes.',
      options: ['Having been read', 'To have read', 'Read being', 'Been reading', 'Having read'],
      answer: 'Having read',
      translation: 'Después de leer las instrucciones con cuidado, armó el estante en minutos.',
      tip: "'Having + participio' indica que la primera acción terminó antes que la segunda.",
      collected_word: 'having read', category: 'advanced_structures',
    },
    {
      id: 'c1-adv-006', level: 'C1', grammar: "Would rather + past",
      sentence: "I'd rather you ___ smoke in here, if you don't mind.",
      options: ["don't", "won't", 'not', "wouldn't", "didn't"],
      answer: "didn't",
      translation: 'Preferiría que no fumaras aquí, si no te molesta.',
      tip: "'Would rather' + sujeto distinto usa pasado simple, aunque el sentido sea presente.",
      collected_word: "didn't", category: 'advanced_structures',
    },
    {
      id: 'c1-perf-001', level: 'C1', grammar: 'Future Perfect',
      sentence: 'By the time you arrive, I ___ the report.',
      options: ['will finish', 'have finished', 'am finishing', 'would finish', 'will have finished'],
      answer: 'will have finished',
      translation: 'Para cuando llegues, habré terminado el informe.',
      tip: "Future Perfect (will have + participio) para algo que estará completo antes de un momento futuro.",
      collected_word: 'will have finished', category: 'perfect_tenses',
    },
    {
      id: 'c1-pass-001', level: 'C1', grammar: 'Passive Reporting Structures',
      sentence: 'He is said ___ the best surgeon in the country.',
      options: ['being', 'that is', 'to being', 'be', 'to be'],
      answer: 'to be',
      translation: 'Se dice que es el mejor cirujano del país.',
      tip: "'It is said that...' puede transformarse en 'He is said to be...'.",
      collected_word: 'to be', category: 'passive_voice',
    },
    {
      id: 'c1-modal-001', level: 'C1', grammar: "Modal Deduction (can't have)",
      sentence: "She ___ have left yet; her coat is still on the chair.",
      options: ["mustn't", "shouldn't", "needn't", "won't", "can't"],
      answer: "can't",
      translation: 'No puede haberse ido todavía; su abrigo sigue en la silla.',
      tip: "Para negar una deducción del pasado: can't have + participio.",
      collected_word: "can't", category: 'continuous_modals',
    },
    {
      id: 'c1-phr-001', level: 'C1', grammar: 'Phrasal Verbs (call off)',
      sentence: 'The project was called ___ due to a lack of funding.',
      options: ['out', 'up', 'down', 'in', 'off'],
      answer: 'off',
      translation: 'El proyecto fue cancelado por falta de fondos.',
      tip: "'Call off' = cancelar algo planificado.",
      collected_word: 'called off', category: 'phrasal_verbs',
    },
    {
      id: 'c1-phr-002', level: 'C1', grammar: 'Phrasal Verbs (put up with)',
      sentence: "I can't ___ with his constant complaining any longer.",
      options: ['get away', 'come across', 'look into', 'break down', 'put up'],
      answer: 'put up',
      translation: 'Ya no soporto más sus quejas constantes.',
      tip: "'Put up with' = tolerar o soportar.",
      collected_word: 'put up with', category: 'phrasal_verbs',
    },
    {
      id: 'c1-prep-001', level: 'C1', grammar: 'Dependent Prepositions (accountable to)',
      sentence: 'The committee is accountable ___ the board for every decision.',
      options: ['for', 'of', 'with', 'on', 'to'],
      answer: 'to',
      translation: 'El comité rinde cuentas ante la junta por cada decisión.',
      tip: "'Accountable to' + persona o entidad; 'accountable for' + lo que se responde.",
      collected_word: 'accountable to', category: 'prepositions',
    },
    {
      id: 'c1-prep-002', level: 'C1', grammar: 'Dependent Prepositions (aptitude for)',
      sentence: 'She has a remarkable aptitude ___ languages.',
      options: ['at', 'with', 'on', 'by', 'for'],
      answer: 'for',
      translation: 'Tiene una aptitud notable para los idiomas.',
      tip: "El sustantivo 'aptitude' va seguido de 'for'.",
      collected_word: 'aptitude for', category: 'prepositions',
    },
    {
      id: 'c1-conn-001', level: 'C1', grammar: 'Connectors (in spite of)',
      sentence: '___ his lack of experience, he got the job.',
      options: ['Even though', 'Whereas', 'Provided', 'Unless', 'In spite of'],
      answer: 'In spite of',
      translation: 'A pesar de su falta de experiencia, consiguió el trabajo.',
      tip: "'In spite of' + sustantivo o gerundio. 'Even though' necesita sujeto + verbo.",
      collected_word: 'in spite of', category: 'connectors',
    },
    {
      id: 'c1-conn-002', level: 'C1', grammar: 'Connectors (so that)',
      sentence: 'He worked two jobs ___ he could provide for his family.',
      options: ['in spite of', 'even though', 'whereas', 'owing to', 'so that'],
      answer: 'so that',
      translation: 'Tenía dos trabajos para poder mantener a su familia.',
      tip: "'So that' introduce el propósito de una acción.",
      collected_word: 'so that', category: 'connectors',
    },
    {
      id: 'c1-vocab-001', level: 'C1', grammar: 'Vocabulary (ambiguous)',
      sentence: "The politician's statement was deliberately ___, so nobody could tell what he really meant.",
      options: ['explicit', 'blunt', 'candid', 'transparent', 'ambiguous'],
      answer: 'ambiguous',
      translation: 'La declaración del político fue deliberadamente ambigua, así que nadie supo qué quiso decir.',
      tip: "'Ambiguous' = que admite más de una interpretación.",
      collected_word: 'ambiguous', category: 'vocabulary',
    },
    {
      id: 'c1-vocab-002', level: 'C1', grammar: 'Collocations (raise doubts)',
      sentence: "The scandal ___ serious doubts about the minister's honesty.",
      options: ['rose', 'arose', 'lifted', 'grew', 'raised'],
      answer: 'raised',
      translation: 'El escándalo generó serias dudas sobre la honestidad del ministro.',
      tip: "Colocación: 'raise doubts / concerns / questions'. 'Rose' y 'arose' no llevan objeto.",
      collected_word: 'raised', category: 'vocabulary',
    },
  ],
    C2: [
    {
      id: 'c2-adv-001', level: 'C2', grammar: 'Mandative Subjunctive (imperative that)',
      sentence: 'It is imperative that every employee ___ the safety protocol.',
      options: ['follows', 'followed', 'will follow', 'is following', 'follow'],
      answer: 'follow',
      translation: 'Es imprescindible que cada empleado siga el protocolo de seguridad.',
      tip: "Tras 'imperative / essential / vital that', el verbo va en forma base para todas las personas.",
      collected_word: 'follow', category: 'advanced_structures',
    },
    {
      id: 'c2-adv-002', level: 'C2', grammar: 'Inversion (Under no circumstances)',
      sentence: 'Under no circumstances ___ leave the building unattended.',
      options: ['you should', 'you must', 'do you', 'are you', 'should you'],
      answer: 'should you',
      translation: 'Bajo ninguna circunstancia debe dejar el edificio sin vigilancia.',
      tip: "Las expresiones negativas al inicio exigen inversión: 'should you leave'.",
      collected_word: 'should you', category: 'advanced_structures',
    },
    {
      id: 'c2-adv-003', level: 'C2', grammar: 'Inversion (Little did ...)',
      sentence: 'Little ___ she know that a surprise party was planned for her.',
      options: ['does', 'was', 'is', 'has', 'did'],
      answer: 'did',
      translation: 'Poco sabía ella que le habían preparado una fiesta sorpresa.',
      tip: "'Little did + sujeto + verbo base' es una estructura literaria muy típica de C2.",
      collected_word: 'did', category: 'advanced_structures',
    },
    {
      id: 'c2-adv-004', level: 'C2', grammar: 'Inversion (So + adjective)',
      sentence: 'So exhausted ___ that he fell asleep at his desk.',
      options: ['he was', 'did he', 'had he', 'were he', 'was he'],
      answer: 'was he',
      translation: 'Estaba tan agotado que se quedó dormido en su escritorio.',
      tip: "'So + adjetivo' al inicio invierte el verbo 'be' y el sujeto: 'So exhausted was he'.",
      collected_word: 'was he', category: 'advanced_structures',
    },
    {
      id: 'c2-adv-005', level: 'C2', grammar: 'Conditional Inversion (Were ... to)',
      sentence: 'Were she to resign tomorrow, the company ___ in serious trouble.',
      options: ['would have been', 'had been', 'is being', 'was', 'would be'],
      answer: 'would be',
      translation: 'Si ella renunciara mañana, la empresa estaría en serios problemas.',
      tip: "'Were + sujeto + to + verbo' sustituye a 'If + sujeto + past' en registro formal.",
      collected_word: 'would be', category: 'advanced_structures',
    },
    {
      id: 'c2-adv-006', level: 'C2', grammar: "Needn't have + past participle",
      sentence: 'You ___ have bothered; I had already fixed it myself.',
      options: ["mustn't", "can't", 'may not', "couldn't", "needn't"],
      answer: "needn't",
      translation: 'No hacía falta que te molestaras; ya lo había arreglado yo mismo.',
      tip: "'Needn't have + participio' = hiciste algo que no era necesario.",
      collected_word: "needn't", category: 'advanced_structures',
    },
    {
      id: 'c2-adv-007', level: 'C2', grammar: 'Inversion (Scarcely ... when)',
      sentence: 'Scarcely had the speech begun ___ the audience started to applaud.',
      options: ['then', 'but', 'since', 'because', 'when'],
      answer: 'when',
      translation: 'Apenas había empezado el discurso cuando el público comenzó a aplaudir.',
      tip: "'Scarcely / Hardly + had ... when' (y 'No sooner ... than'). Ojo: scarcely y hardly van con 'when'.",
      collected_word: 'when', category: 'advanced_structures',
    },
    {
      id: 'c2-idiom-001', level: 'C2', grammar: 'Idioms (bear fruit)',
      sentence: 'After years of hard work, her efforts finally ___ fruit.',
      options: ['bear', 'bared', 'bored', 'beared', 'bore'],
      answer: 'bore',
      translation: 'Tras años de trabajo duro, sus esfuerzos por fin dieron fruto.',
      tip: "'Bear fruit' = dar frutos o resultados. El pasado de 'bear' es 'bore'.",
      collected_word: 'bore fruit', category: 'idioms',
    },
    {
      id: 'c2-idiom-002', level: 'C2', grammar: 'Idioms (bite the bullet)',
      sentence: "He's always ready to ___ the bullet and take responsibility.",
      options: ['chew', 'swallow', 'hit', 'catch', 'bite'],
      answer: 'bite',
      translation: 'Siempre está dispuesto a afrontar lo difícil y asumir la responsabilidad.',
      tip: "'Bite the bullet' = aguantar y afrontar una situación desagradable.",
      collected_word: 'bite the bullet', category: 'idioms',
    },
    {
      id: 'c2-idiom-003', level: 'C2', grammar: 'Idioms (break the ice)',
      sentence: 'She decided to ___ the ice by telling a funny story.',
      options: ['crack', 'melt', 'cut', 'smash', 'break'],
      answer: 'break',
      translation: 'Decidió romper el hielo contando una historia graciosa.',
      tip: "'Break the ice' = aliviar la tensión inicial en un encuentro.",
      collected_word: 'break the ice', category: 'idioms',
    },
    {
      id: 'c2-idiom-004', level: 'C2', grammar: 'Idioms (double-edged sword)',
      sentence: 'The new regulations are a double-edged ___: they protect workers but raise costs.',
      options: ['knife', 'blade', 'axe', 'weapon', 'sword'],
      answer: 'sword',
      translation: 'La nueva normativa es un arma de doble filo: protege a los trabajadores pero eleva los costos.',
      tip: "'Double-edged sword' = algo con ventajas y desventajas a la vez.",
      collected_word: 'double-edged sword', category: 'idioms',
    },
    {
      id: 'c2-idiom-005', level: 'C2', grammar: 'Idioms (once in a blue moon)',
      sentence: 'We only see each other once in a blue ___.',
      options: ['sky', 'sea', 'star', 'day', 'moon'],
      answer: 'moon',
      translation: 'Nos vemos muy de vez en cuando.',
      tip: "'Once in a blue moon' = muy raramente.",
      collected_word: 'blue moon', category: 'idioms',
    },
    {
      id: 'c2-vocab-001', level: 'C2', grammar: 'Collocations (call into question)',
      sentence: 'The findings ___ into question the validity of the earlier study.',
      options: ['make', 'do', 'take', 'give', 'call'],
      answer: 'call',
      translation: 'Los hallazgos ponen en duda la validez del estudio anterior.',
      tip: "Colocación académica: 'call something into question'.",
      collected_word: 'call', category: 'vocabulary',
    },
    {
      id: 'c2-vocab-002', level: 'C2', grammar: 'Nuance (noncommittal)',
      sentence: "The diplomat's response was deliberately ___, avoiding any firm commitment.",
      options: ['unequivocal', 'forthright', 'emphatic', 'adamant', 'noncommittal'],
      answer: 'noncommittal',
      translation: 'La respuesta del diplomático fue deliberadamente evasiva, sin ningún compromiso firme.',
      tip: "'Noncommittal' = que no se compromete con una postura.",
      collected_word: 'noncommittal', category: 'vocabulary',
    },
    {
      id: 'c2-vocab-003', level: 'C2', grammar: 'Nuance (tactless)',
      sentence: 'Her ___ remarks offended several guests, though she claimed she meant no harm.',
      options: ['tactful', 'diplomatic', 'discreet', 'courteous', 'tactless'],
      answer: 'tactless',
      translation: 'Sus comentarios poco delicados ofendieron a varios invitados, aunque dijo que no quería hacer daño.',
      tip: "'Tactless' = que carece de tacto. Su opuesto es 'tactful'.",
      collected_word: 'tactless', category: 'vocabulary',
    },
    {
      id: 'c2-vocab-004', level: 'C2', grammar: 'Word Formation (grandeur)',
      sentence: 'The ___ of the mountain landscape took our breath away.',
      options: ['grand', 'grandiose', 'grandly', 'grandest', 'grandeur'],
      answer: 'grandeur',
      translation: 'La grandiosidad del paisaje montañoso nos dejó sin aliento.',
      tip: "Después de 'the' y antes de 'of' necesitamos un sustantivo: 'grandeur'.",
      collected_word: 'grandeur', category: 'vocabulary',
    },
    {
      id: 'c2-prep-001', level: 'C2', grammar: 'Dependent Prepositions (liable for)',
      sentence: 'The company is not liable ___ damage caused by natural disasters.',
      options: ['of', 'to', 'with', 'from', 'for'],
      answer: 'for',
      translation: 'La empresa no es responsable de los daños causados por desastres naturales.',
      tip: "'Liable for' = legalmente responsable de algo.",
      collected_word: 'liable for', category: 'prepositions',
    },
    {
      id: 'c2-prep-002', level: 'C2', grammar: 'Dependent Prepositions (oblivious to)',
      sentence: 'He was oblivious ___ the fact that everyone was staring at him.',
      options: ['for', 'about', 'with', 'by', 'to'],
      answer: 'to',
      translation: 'No se daba cuenta de que todos lo estaban mirando.',
      tip: "'Oblivious to' = ajeno a, sin ser consciente de.",
      collected_word: 'oblivious to', category: 'prepositions',
    },
    {
      id: 'c2-conn-001', level: 'C2', grammar: 'Linkers (contrary to)',
      sentence: '___ what you may think, the decision was not made lightly.',
      options: ['Opposite of', 'Against to', 'Instead', 'In contrast', 'Contrary to'],
      answer: 'Contrary to',
      translation: 'Contrariamente a lo que puedas pensar, la decisión no se tomó a la ligera.',
      tip: "'Contrary to' + sustantivo o cláusula nominal introduce algo opuesto a lo esperado.",
      collected_word: 'contrary to', category: 'connectors',
    },
    {
      id: 'c2-conn-002', level: 'C2', grammar: 'Linkers (nevertheless)',
      sentence: 'The results were promising; ___, further trials are needed.',
      options: ['moreover', 'therefore', 'besides', 'consequently', 'nevertheless'],
      answer: 'nevertheless',
      translation: 'Los resultados fueron prometedores; no obstante, se necesitan más ensayos.',
      tip: "'Nevertheless' marca contraste con lo anterior. 'Moreover' y 'besides' añaden información.",
      collected_word: 'nevertheless', category: 'connectors',
    },
  ],
};

// Categorías de colección con metadatos de UI
export const COLLECTION_CATEGORIES = {
  present_simple:     { label: 'Present Simple',           emoji: '🟢', color: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  past_simple:        { label: 'Past Simple',               emoji: '🔵', color: 'bg-blue-100 text-blue-700 border-blue-200' },
  continuous_modals:  { label: 'Continuous & Modals',       emoji: '🟣', color: 'bg-violet-100 text-violet-700 border-violet-200' },
  comparatives:       { label: 'Comparatives & Adjectives', emoji: '🟡', color: 'bg-amber-100 text-amber-700 border-amber-200' },
  prepositions:       { label: 'Prepositions',              emoji: '🔴', color: 'bg-rose-100 text-rose-700 border-rose-200' },
  frequency_adverbs:  { label: 'Frequency Adverbs',         emoji: '🟠', color: 'bg-orange-100 text-orange-700 border-orange-200' },
  connectors:         { label: 'Connectors',                emoji: '⚪', color: 'bg-slate-100 text-slate-700 border-slate-200' },
  vocabulary:         { label: 'Vocabulary in Context',     emoji: '💙', color: 'bg-sky-100 text-sky-700 border-sky-200' },
    perfect_tenses:      { label: 'Perfect Tenses',      emoji: '🟤', color: 'bg-stone-100 text-stone-700 border-stone-200' },
  conditionals:        { label: 'Conditionals & Wishes', emoji: '🟩', color: 'bg-lime-100 text-lime-700 border-lime-200' },
  passive_voice:       { label: 'Passive Voice',       emoji: '🟦', color: 'bg-indigo-100 text-indigo-700 border-indigo-200' },
  relative_clauses:    { label: 'Relative Clauses',    emoji: '🟪', color: 'bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200' },
  verb_patterns:       { label: 'Verb Patterns',       emoji: '🟧', color: 'bg-yellow-100 text-yellow-700 border-yellow-200' },
  phrasal_verbs:       { label: 'Phrasal Verbs',       emoji: '🔶', color: 'bg-teal-100 text-teal-700 border-teal-200' },
  reported_speech:     { label: 'Reported Speech',     emoji: '💬', color: 'bg-cyan-100 text-cyan-700 border-cyan-200' },
  advanced_structures: { label: 'Advanced Structures', emoji: '⭐', color: 'bg-purple-100 text-purple-700 border-purple-200' },
  to_be:            { label: 'Verb To Be',        emoji: '🧩', color: 'bg-green-100 text-green-700 border-green-200' },
  nouns_articles:   { label: 'Nouns & Articles',  emoji: '📦', color: 'bg-pink-100 text-pink-700 border-pink-200' },
  pronouns:         { label: 'Pronouns',          emoji: '👤', color: 'bg-red-100 text-red-700 border-red-200' },
  question_words:   { label: 'Question Words',    emoji: '❓', color: 'bg-blue-100 text-blue-700 border-blue-200' },
  idioms:           { label: 'Idioms',            emoji: '🎭', color: 'bg-zinc-100 text-zinc-700 border-zinc-200' },
};

// Frases ejemplo para cada palabra coleccionada (para la ficha de colección)
export const WORD_EXAMPLES = {
  
  // ── A1 ──
  'am':                 { phonetic: '/æm/', example: 'I am happy today.', exampleEs: 'Estoy feliz hoy.' },
  'is':                 { phonetic: '/ɪz/', example: 'He is my brother.', exampleEs: 'Él es mi hermano.' },
  'are':                { phonetic: '/ɑːr/', example: 'We are students.', exampleEs: 'Somos estudiantes.' },
  "isn't":              { phonetic: '/ˈɪzənt/', example: "She isn't tired.", exampleEs: 'Ella no está cansada.' },
  'there is':           { phonetic: '/ðɛər ɪz/', example: 'There is a park near my house.', exampleEs: 'Hay un parque cerca de mi casa.' },
  'an':                 { phonetic: '/æn/', example: 'She has an orange.', exampleEs: 'Ella tiene una naranja.' },
  'chairs':             { phonetic: '/tʃeəz/', example: 'We need four chairs.', exampleEs: 'Necesitamos cuatro sillas.' },
  'children':           { phonetic: '/ˈtʃɪldrən/', example: 'The children are happy.', exampleEs: 'Los niños están felices.' },
  "don't":              { phonetic: '/doʊnt/', example: "I don't know him.", exampleEs: 'No lo conozco.' },
  'do you':             { phonetic: '/duː juː/', example: 'Do you like pizza?', exampleEs: '¿Te gusta la pizza?' },
  'does she':           { phonetic: '/dʌz ʃiː/', example: 'Does she work here?', exampleEs: '¿Ella trabaja aquí?' },
  'her':                { phonetic: '/hɜːr/', example: 'Her car is red.', exampleEs: 'Su coche es rojo.' },
  'him':                { phonetic: '/hɪm/', example: 'I see him every day.', exampleEs: 'Lo veo todos los días.' },
  'in the classroom':   { phonetic: '/ɪn ðə ˈklɑːsruːm/', example: 'The teacher is in the classroom.', exampleEs: 'La profesora está en el salón.' },
  'can':                { phonetic: '/kæn/', example: 'I can cook pasta.', exampleEs: 'Sé cocinar pasta.' },
  'is sleeping':        { phonetic: '/ɪz ˈsliːpɪŋ/', example: 'The dog is sleeping.', exampleEs: 'El perro está durmiendo.' },
  'what':               { phonetic: '/wɒt/', example: 'What is this?', exampleEs: '¿Qué es esto?' },
  'where':              { phonetic: '/wɛər/', example: 'Where is the station?', exampleEs: '¿Dónde está la estación?' },
  'Sunday':             { phonetic: '/ˈsʌndeɪ/', example: 'We rest on Sunday.', exampleEs: 'Descansamos el domingo.' },
  'blue':               { phonetic: '/bluː/', example: 'I like your blue shirt.', exampleEs: 'Me gusta tu camisa azul.' },

  'eats':           { phonetic: '/iːts/', example: 'She eats an apple every day.', exampleEs: 'Ella come una manzana todos los días.' },
  'has':            { phonetic: '/hæz/', example: 'He has a great idea.', exampleEs: 'Él tiene una gran idea.' },
  'cooked':         { phonetic: '/kʊkt/', example: 'She cooked dinner last night.', exampleEs: 'Ella cocinó la cena anoche.' },
  'went':           { phonetic: '/wɛnt/', example: 'They went to the park.', exampleEs: 'Ellos fueron al parque.' },
  'playing':        { phonetic: '/ˈpleɪɪŋ/', example: 'He is playing football.', exampleEs: 'Él está jugando fútbol.' },
  'agree':          { phonetic: '/əˈɡriː/', example: 'I agree with you.', exampleEs: 'Estoy de acuerdo contigo.' },
  'at':             { phonetic: '/æt/', example: 'The class starts at 9 a.m.', exampleEs: 'La clase empieza a las 9 a.m.' },
  'on':             { phonetic: '/ɒn/', example: 'We meet on Mondays.', exampleEs: 'Nos reunimos los lunes.' },
  'in':             { phonetic: '/ɪn/', example: 'She lives in London.', exampleEs: 'Ella vive en Londres.' },
  'interested in':  { phonetic: '/ˈɪntrɪstɪd ɪn/', example: 'He is interested in music.', exampleEs: 'Él está interesado en la música.' },
  'faster':         { phonetic: '/ˈfɑːstər/', example: 'Trains are faster than buses.', exampleEs: 'Los trenes son más rápidos que los autobuses.' },
  'better':         { phonetic: '/ˈbɛtər/', example: 'This phone is better.', exampleEs: 'Este teléfono es mejor.' },
  'more expensive': { phonetic: '/mɔːr ɪkˈspɛnsɪv/', example: 'Gold is more expensive than silver.', exampleEs: 'El oro es más caro que la plata.' },
  'always':         { phonetic: '/ˈɔːlweɪz/', example: 'She always arrives early.', exampleEs: 'Ella siempre llega temprano.' },
  'usually':        { phonetic: '/ˈjuːʒuəli/', example: 'He usually drinks coffee.', exampleEs: 'Él usualmente bebe café.' },
  'rarely':         { phonetic: '/ˈreərli/', example: 'They rarely watch TV.', exampleEs: 'Ellos rara vez ven televisión.' },
  'because':        { phonetic: '/bɪˈkɒz/', example: 'I stayed home because it rained.', exampleEs: 'Me quedé en casa porque llovió.' },
  'so':             { phonetic: '/soʊ/', example: 'It was cold, so I wore a coat.', exampleEs: 'Hacía frío, así que usé un abrigo.' },
  'luggage':        { phonetic: '/ˈlʌɡɪdʒ/', example: 'Please collect your luggage.', exampleEs: 'Por favor recoge tu equipaje.' },
  'appointment':    { phonetic: '/əˈpɔɪntmənt/', example: 'I have a dentist appointment.', exampleEs: 'Tengo cita con el dentista.' },
    // ── B1 ──
  'since':          { phonetic: '/sɪns/', example: 'I have lived here since 2020.', exampleEs: 'Vivo aquí desde 2020.' },
  'has been':       { phonetic: '/hæz biːn/', example: 'He has been to Japan twice.', exampleEs: 'Él ha estado en Japón dos veces.' },
  'yet':            { phonetic: '/jɛt/', example: "She hasn't called me yet.", exampleEs: 'Todavía no me ha llamado.' },
  'was cooking':    { phonetic: '/wɒz ˈkʊkɪŋ/', example: 'I was cooking when you called.', exampleEs: 'Estaba cocinando cuando llamaste.' },
  'rains':          { phonetic: '/reɪnz/', example: 'If it rains, we stay home.', exampleEs: 'Si llueve, nos quedamos en casa.' },
  'had':            { phonetic: '/hæd/', example: 'If I had a car, I would drive.', exampleEs: 'Si tuviera un coche, conduciría.' },
  'is going to':    { phonetic: '/ɪz ˈɡoʊɪŋ tuː/', example: "It's going to be a long day.", exampleEs: 'Va a ser un día largo.' },
  'must':           { phonetic: '/mʌst/', example: 'You must show your passport.', exampleEs: 'Debes mostrar tu pasaporte.' },
  "don't have to":  { phonetic: '/doʊnt hæv tuː/', example: "You don't have to come.", exampleEs: 'No tienes que venir.' },
  'is spoken':      { phonetic: '/ɪz ˈspoʊkən/', example: 'French is spoken in Canada.', exampleEs: 'Se habla francés en Canadá.' },
  'was painted':    { phonetic: '/wɒz ˈpeɪntɪd/', example: 'The wall was painted blue.', exampleEs: 'La pared fue pintada de azul.' },
  'who':            { phonetic: '/huː/', example: 'The man who called is my uncle.', exampleEs: 'El hombre que llamó es mi tío.' },
  'where':          { phonetic: '/wɛər/', example: 'That is the hotel where we stayed.', exampleEs: 'Ese es el hotel donde nos alojamos.' },
  'listening':      { phonetic: '/ˈlɪsənɪŋ/', example: 'I love listening to podcasts.', exampleEs: 'Me encanta escuchar podcasts.' },
  'to buy':         { phonetic: '/tuː baɪ/', example: 'I want to buy a new phone.', exampleEs: 'Quiero comprar un teléfono nuevo.' },
  'used to':        { phonetic: '/juːst tuː/', example: 'We used to live in Cork.', exampleEs: 'Antes vivíamos en Cork.' },
  'afraid of':      { phonetic: '/əˈfreɪd ɒv/', example: "He's afraid of heights.", exampleEs: 'Le tiene miedo a las alturas.' },
  'turn down':      { phonetic: '/tɜːn daʊn/', example: 'Can you turn down the TV?', exampleEs: '¿Puedes bajar el volumen de la tele?' },
  'although':       { phonetic: '/ɔːlˈðoʊ/', example: 'Although he was tired, he kept working.', exampleEs: 'Aunque estaba cansado, siguió trabajando.' },
  'hire':           { phonetic: '/ˈhaɪər/', example: 'They hired two new teachers.', exampleEs: 'Contrataron a dos profesores nuevos.' },

  // ── B2 ──
  'has been crying':   { phonetic: '/hæz biːn ˈkraɪɪŋ/', example: 'The baby has been crying all night.', exampleEs: 'El bebé ha estado llorando toda la noche.' },
  'had left':          { phonetic: '/hæd lɛft/', example: 'When I got there, she had left.', exampleEs: 'Cuando llegué, ella ya se había ido.' },
  'would have passed': { phonetic: '/wʊd hæv pɑːst/', example: 'He would have passed if he had studied.', exampleEs: 'Habría aprobado si hubiera estudiado.' },
  'wish I had':        { phonetic: '/wɪʃ aɪ hæd/', example: 'I wish I had a bigger flat.', exampleEs: 'Ojalá tuviera un piso más grande.' },
  'had finished':      { phonetic: '/hæd ˈfɪnɪʃt/', example: 'She said she had finished.', exampleEs: 'Dijo que había terminado.' },
  'I was going':       { phonetic: '/aɪ wɒz ˈɡoʊɪŋ/', example: 'He asked where I was going.', exampleEs: 'Preguntó adónde iba.' },
  'must be finished':  { phonetic: '/mʌst biː ˈfɪnɪʃt/', example: 'The work must be finished today.', exampleEs: 'El trabajo debe estar terminado hoy.' },
  'repaired':          { phonetic: '/rɪˈpeəd/', example: 'I had my phone repaired.', exampleEs: 'Hice reparar mi teléfono.' },
  'which':             { phonetic: '/wɪtʃ/', example: 'The book, which I read, was great.', exampleEs: 'El libro, que leí, era genial.' },
  'whose':             { phonetic: '/huːz/', example: 'She is the girl whose bag was stolen.', exampleEs: 'Ella es la chica a quien le robaron el bolso.' },
  'had we':            { phonetic: '/hæd wiː/', example: 'Never had we seen such a view.', exampleEs: 'Nunca habíamos visto una vista así.' },
  'must have':         { phonetic: '/mʌst hæv/', example: 'He must have forgotten the keys.', exampleEs: 'Debe de haber olvidado las llaves.' },
  'should have':       { phonetic: '/ʃʊd hæv/', example: 'I should have called you.', exampleEs: 'Debería haberte llamado.' },
  'locking':           { phonetic: '/ˈlɒkɪŋ/', example: 'I remember locking the car.', exampleEs: 'Recuerdo haber cerrado el coche con llave.' },
  'taking':            { phonetic: '/ˈteɪkɪŋ/', example: 'He suggested taking a break.', exampleEs: 'Sugirió tomar un descanso.' },
  'despite':           { phonetic: '/dɪˈspaɪt/', example: 'Despite the cold, we went out.', exampleEs: 'A pesar del frío, salimos.' },
  'however':           { phonetic: '/haʊˈɛvər/', example: 'It was cheap. However, it broke.', exampleEs: 'Era barato. Sin embargo, se rompió.' },
  'apologise for':     { phonetic: '/əˈpɒlədʒaɪz fɔːr/', example: 'I apologise for the delay.', exampleEs: 'Me disculpo por el retraso.' },
  'come up with':      { phonetic: '/kʌm ʌp wɪð/', example: 'She came up with a great idea.', exampleEs: 'Ella se le ocurrió una gran idea.' },
  'come into effect':  { phonetic: '/kʌm ˈɪntuː ɪˈfɛkt/', example: 'The rule comes into effect on Monday.', exampleEs: 'La norma entra en vigor el lunes.' },

  // ── C1 ──
  'would be living':    { phonetic: '/wʊd biː ˈlɪvɪŋ/', example: 'I would be living abroad now.', exampleEs: 'Ahora estaría viviendo en el extranjero.' },
  "hadn't sent":        { phonetic: '/ˈhædənt sɛnt/', example: "I wish I hadn't sent it.", exampleEs: 'Ojalá no lo hubiera enviado.' },
  'would have missed':  { phonetic: '/wʊd hæv mɪst/', example: 'We would have missed the flight.', exampleEs: 'Habríamos perdido el vuelo.' },
  'should':             { phonetic: '/ʃʊd/', example: 'Should you need help, call me.', exampleEs: 'Si necesitara ayuda, llámeme.' },
  'did he arrive':      { phonetic: '/dɪd hiː əˈraɪv/', example: 'Not only did he arrive early, he helped us.', exampleEs: 'No solo llegó temprano, sino que nos ayudó.' },
  'she be':             { phonetic: '/ʃiː biː/', example: 'They demand that she be present.', exampleEs: 'Exigen que ella esté presente.' },
  'What ... is':        { phonetic: '/wɒt ... ɪz/', example: 'What I want is peace.', exampleEs: 'Lo que quiero es paz.' },
  'having read':        { phonetic: '/ˈhævɪŋ rɛd/', example: 'Having read the book, I saw the film.', exampleEs: 'Tras leer el libro, vi la película.' },
  "didn't":             { phonetic: '/ˈdɪdənt/', example: "I'd rather you didn't call late.", exampleEs: 'Preferiría que no llamaras tarde.' },
  'will have finished': { phonetic: '/wɪl hæv ˈfɪnɪʃt/', example: 'She will have finished by noon.', exampleEs: 'Habrá terminado para el mediodía.' },
  'to be':              { phonetic: '/tuː biː/', example: 'He is believed to be innocent.', exampleEs: 'Se cree que es inocente.' },
  "can't":              { phonetic: '/kɑːnt/', example: "He can't have known.", exampleEs: 'No puede haberlo sabido.' },
  'called off':         { phonetic: '/kɔːld ɒf/', example: 'The match was called off.', exampleEs: 'El partido fue cancelado.' },
  'put up with':        { phonetic: '/pʊt ʌp wɪð/', example: "I can't put up with the noise.", exampleEs: 'No soporto el ruido.' },
  'accountable to':     { phonetic: '/əˈkaʊntəbl tuː/', example: 'He is accountable to the CEO.', exampleEs: 'Rinde cuentas ante el director.' },
  'aptitude for':       { phonetic: '/ˈæptɪtjuːd fɔːr/', example: 'She has an aptitude for maths.', exampleEs: 'Tiene aptitud para las matemáticas.' },
  'in spite of':        { phonetic: '/ɪn spaɪt ɒv/', example: 'In spite of the rain, we went.', exampleEs: 'A pesar de la lluvia, fuimos.' },
  'so that':            { phonetic: '/soʊ ðæt/', example: 'Speak slowly so that I understand.', exampleEs: 'Habla despacio para que entienda.' },
  'ambiguous':          { phonetic: '/æmˈbɪɡjuəs/', example: 'The answer was ambiguous.', exampleEs: 'La respuesta fue ambigua.' },
  'raised':             { phonetic: '/reɪzd/', example: 'It raised many questions.', exampleEs: 'Generó muchas preguntas.' },

  // ── C2 ──
  'follow':             { phonetic: '/ˈfɒloʊ/', example: 'It is vital that he follow the rules.', exampleEs: 'Es vital que siga las reglas.' },
  'should you':         { phonetic: '/ʃʊd juː/', example: 'Never should you give up.', exampleEs: 'Nunca debes rendirte.' },
  'did':                { phonetic: '/dɪd/', example: 'Little did I know.', exampleEs: 'Poco sabía yo.' },
  'was he':             { phonetic: '/wɒz hiː/', example: 'So tired was he that he slept.', exampleEs: 'Estaba tan cansado que durmió.' },
  'would be':           { phonetic: '/wʊd biː/', example: 'Were he to leave, we would be lost.', exampleEs: 'Si se fuera, estaríamos perdidos.' },
  "needn't":            { phonetic: '/ˈniːdnt/', example: "You needn't have come.", exampleEs: 'No hacía falta que vinieras.' },
  'when':               { phonetic: '/wɛn/', example: 'Hardly had I sat down when it rang.', exampleEs: 'Apenas me senté cuando sonó.' },
  'bore fruit':         { phonetic: '/bɔːr fruːt/', example: 'Their plan bore fruit.', exampleEs: 'Su plan dio frutos.' },
  'bite the bullet':    { phonetic: '/baɪt ðə ˈbʊlɪt/', example: 'I had to bite the bullet.', exampleEs: 'Tuve que apechugar.' },
  'break the ice':      { phonetic: '/breɪk ði aɪs/', example: 'A joke can break the ice.', exampleEs: 'Un chiste puede romper el hielo.' },
  'double-edged sword': { phonetic: '/ˈdʌbl ɛdʒd sɔːd/', example: 'Fame is a double-edged sword.', exampleEs: 'La fama es un arma de doble filo.' },
  'blue moon':          { phonetic: '/bluː muːn/', example: 'He calls once in a blue moon.', exampleEs: 'Llama muy de vez en cuando.' },
  'call':               { phonetic: '/kɔːl/', example: 'It calls his story into question.', exampleEs: 'Pone en duda su historia.' },
  'noncommittal':       { phonetic: '/ˌnɒnkəˈmɪtl/', example: 'He gave a noncommittal answer.', exampleEs: 'Dio una respuesta evasiva.' },
  'tactless':           { phonetic: '/ˈtæktləs/', example: 'That was a tactless question.', exampleEs: 'Esa fue una pregunta sin tacto.' },
  'grandeur':           { phonetic: '/ˈɡrændʒər/', example: 'The grandeur of the palace is stunning.', exampleEs: 'La grandiosidad del palacio es impresionante.' },
  'liable for':         { phonetic: '/ˈlaɪəbl fɔːr/', example: 'He is liable for the damage.', exampleEs: 'Es responsable del daño.' },
  'oblivious to':       { phonetic: '/əˈblɪviəs tuː/', example: 'She was oblivious to the danger.', exampleEs: 'Era ajena al peligro.' },
  'contrary to':        { phonetic: '/ˈkɒntrəri tuː/', example: 'Contrary to belief, it is safe.', exampleEs: 'Contrariamente a lo que se cree, es seguro.' },
  'nevertheless':       { phonetic: '/ˌnɛvəðəˈlɛs/', example: 'It was hard; nevertheless, she won.', exampleEs: 'Fue difícil; no obstante, ganó.' },
};

// Niveles CEFR disponibles (solo A2 implementado en esta versión)
// Niveles CEFR disponibles (A2, B1 y B2 implementados)
export const CEFR_LEVELS = [
  { id: 'A1', label: 'A1', description: 'Principiante',   available: true },
  { id: 'A2', label: 'A2', description: 'Básico',         available: true },
  { id: 'B1', label: 'B1', description: 'Pre-intermedio', available: true },
  { id: 'B2', label: 'B2', description: 'Intermedio',     available: true },
  { id: 'C1', label: 'C1', description: 'Avanzado',       available: true },
  { id: 'C2', label: 'C2', description: 'Maestría',       available: true },
];
